import { z } from 'zod';
import { ErrorMessagesMap } from './errors/ErrorMessagesMap.js';
// Enable ErrorMap with generic error messages
z.setErrorMap(ErrorMessagesMap);
export * from './cidr/CIDRUtils.js';
export * from './ip/IPValidation.js';
export { z };

//# sourceMappingURL=index.js.map